import React from 'react';
import PropTypes from 'prop-types';
import Select from 'tradera-components/form-controls/select';

export const SelectFilter = ({
    filter = {},
    handleFilterChange,
    id,
    label,
    selectClassName
}) => {
    const { parameter, selectedValue, options } = filter;
    if (!options) {
        return null;
    }

    return (
        <Select
            id={id}
            options={options}
            selectedValue={selectedValue}
            label={label}
            handleChange={e => {
                handleFilterChange(parameter, e);
            }}
            className="d-flex"
            selectClassName={selectClassName}
        />
    );
};

SelectFilter.propTypes = {
    filter: PropTypes.object,
    handleFilterChange: PropTypes.func,
    id: PropTypes.string.isRequired,
    label: PropTypes.string,
    selectClassName: PropTypes.string
};
